import * as React from 'react';
import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Container from 'components/Container';
import ShoppingCartForUpdating from './ShoppingCartForUpdating';
import { OrderProduct, Languages, CurrencyObject } from 'common/types';
import { OrderObject } from 'common/types';
import { useTranslation } from 'services/localization';

interface OwnProps {
	open: boolean;
	onClose: () => void;
	activeRental: OrderObject;
	newProducts: OrderProduct[];
	lang: Languages;
	activeShopperId: string;
	currency: CurrencyObject;
	overbookedVariantIds: string[];
}

type Props = OwnProps & WithStyles<typeof styles>;

export const ShoppingCartDialogUpdating = (props: Props) => {
	const {
		classes,
		open,
		onClose,
		activeRental,
		newProducts,
		lang,
		activeShopperId,
		currency,
		overbookedVariantIds,
	} = props;
	const { t } = useTranslation();

	return (
		<Dialog fullScreen open={open} onClose={onClose}>
			<AppBar
				color="default"
				sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
				position="relative"
				elevation={0}
			>
				<Toolbar>
					<IconButton color="inherit" onClick={onClose} aria-label="Close" size="large">
						<CloseIcon />
					</IconButton>
					<Typography variant="h5" color="inherit" style={{ flexGrow: 1 }}>
						{t('common:shoppingCart')}
					</Typography>
				</Toolbar>
			</AppBar>
			<Container className={classes.container}>
				<ShoppingCartForUpdating
					activeRental={activeRental}
					newProducts={newProducts}
					lang={lang}
					activeShopperId={activeShopperId}
					currency={currency}
					overbookedVariantIds={overbookedVariantIds}
				/>
			</Container>
		</Dialog>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		container: {
			backgroundColor: theme.palette.background.default,
			display: 'flex',
		},
	});

export default withStyles(styles)(ShoppingCartDialogUpdating);
